import { useEffect, useState } from "react";
import { HALLOWEEN_TARGET } from "@/lib/format";

function diff(target) {
  const now = new Date();
  let s = Math.max(0, Math.floor((target.getTime() - now.getTime()) / 1000));
  const days = Math.floor(s / 86400);
  s -= days * 86400;
  const hours = Math.floor(s / 3600);
  s -= hours * 3600;
  const mins = Math.floor(s / 60);
  const secs = s - mins * 60;
  return { days, hours, mins, secs };
}

export default function CountdownTimer({ compact = false }) {
  const [t, setT] = useState(() => diff(HALLOWEEN_TARGET));
  useEffect(() => {
    const id = setInterval(() => setT(diff(HALLOWEEN_TARGET)), 1000);
    return () => clearInterval(id);
  }, []);

  const pad = (n) => String(n).padStart(2, "0");
  const cells = [
    { v: t.days, l: "Jours" },
    { v: t.hours, l: "Heures" },
    { v: t.mins, l: "Min" },
    { v: t.secs, l: "Sec" },
  ];

  if (compact) {
    return (
      <span className="font-mono-tech font-bold tabular-nums" data-testid="countdown-compact">
        {pad(t.days)}j : {pad(t.hours)}h : {pad(t.mins)}m : <span className="animate-pulse-glow">{pad(t.secs)}s</span>
      </span>
    );
  }

  return (
    <div className="flex items-center gap-3 sm:gap-4" data-testid="countdown-timer">
      {cells.map((c, i) => (
        <div key={c.l} className="flex items-center gap-3 sm:gap-4">
          <div className="flex flex-col items-center">
            <div className="gothic-card rounded-lg px-3 py-2 sm:px-5 sm:py-3 min-w-[52px] sm:min-w-[76px] text-center">
              <span
                className={`font-mono-tech text-2xl sm:text-4xl font-extrabold text-amber-400 tabular-nums ${
                  c.l === "Sec" ? "animate-pulse-glow" : ""
                }`}
              >
                {pad(c.v)}
              </span>
            </div>
            <span className="mt-2 text-[10px] sm:text-xs uppercase tracking-widest text-stone-500 font-mono-tech">
              {c.l}
            </span>
          </div>
          {i < cells.length - 1 && <span className="text-amber-600/60 text-2xl font-bold -mt-5">:</span>}
        </div>
      ))}
    </div>
  );
}
